// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css-emotion/src/Css.bs.js");
var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var IOUtils = require("../../../shared/src/IOUtils.bs.js");
var DomUtils = require("../../../shared/src/DomUtils.bs.js");
var MathUtils = require("../../../shared/src/MathUtils.bs.js");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var ReactUtils = require("../../../shared/src/ReactUtils.bs.js");
var Relude_Int = require("relude/src/Relude_Int.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var StringUtils = require("../../../shared/src/StringUtils.bs.js");
var BrowserStyle = require("../BrowserStyle.bs.js");
var Relude_Float = require("relude/src/Relude_Float.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Result = require("relude/src/Relude_Result.bs.js");
var Relude_String = require("relude/src/Relude_String.bs.js");
var Relude_Tuple2 = require("relude/src/Relude_Tuple2.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var Css_AtomicTypes = require("bs-css/src/Css_AtomicTypes.bs.js");
var BrowserComponents_Icon = require("./BrowserComponents_Icon.bs.js");
var BrowserComponents_Field = require("./BrowserComponents_Field.bs.js");
var BrowserComponents_Spacer = require("./BrowserComponents_Spacer.bs.js");
var BrowserComponents_FlexRow = require("./BrowserComponents_FlexRow.bs.js");
var ReactPlacesAutocomplete = require("react-places-autocomplete").default;
var BrowserBindings_PlacesAutoComplete = require("../bindings/BrowserBindings_PlacesAutoComplete.bs.js");

var inputContainer = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.display(BrowserStyle.flexBox),
      tl: {
        hd: BrowserStyle.backgroundColor({
              TAG: /* White */7,
              _0: /* Light */2
            }),
        tl: {
          hd: BrowserStyle.position("relative"),
          tl: /* [] */0
        }
      }
    });

var icon = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.height(BrowserStyle.pct(100.0)),
      tl: {
        hd: BrowserStyle.position("absolute"),
        tl: {
          hd: BrowserStyle.left(BrowserStyle.rem(0.75)),
          tl: {
            hd: BrowserStyle.zIndex(5),
            tl: /* [] */0
          }
        }
      }
    });

function input(hasIcon) {
  return Curry._1(BrowserStyle.style, BrowserStyle.withFont(undefined, /* Quicksand */0, /* Large */4, undefined)({
                  hd: BrowserStyle.backgroundColor({
                        TAG: /* White */7,
                        _0: /* Light */2
                      }),
                  tl: {
                    hd: BrowserStyle.border(BrowserStyle.rem(0.125), "solid", {
                          TAG: /* Grey */2,
                          _0: /* Medium */2
                        }),
                    tl: {
                      hd: BrowserStyle.borderRadius(BrowserStyle.Input.borderRadius),
                      tl: {
                        hd: BrowserStyle.boxShadow(/* XSmall */0),
                        tl: {
                          hd: BrowserStyle.color({
                                TAG: /* Grey */2,
                                _0: /* Dark */1
                              }),
                          tl: {
                            hd: BrowserStyle.disabled({
                                  hd: BrowserStyle.backgroundColor({
                                        TAG: /* Grey */2,
                                        _0: /* Light */3
                                      }),
                                  tl: {
                                    hd: BrowserStyle.color({
                                          TAG: /* Grey */2,
                                          _0: /* Dark */1
                                        }),
                                    tl: /* [] */0
                                  }
                                }),
                            tl: {
                              hd: BrowserStyle.outlineStyle(BrowserStyle.none),
                              tl: {
                                hd: BrowserStyle.padding(BrowserStyle.rem(0.75)),
                                tl: {
                                  hd: BrowserStyle.paddingLeft(BrowserStyle.rem(hasIcon ? 2.5 : 0.75)),
                                  tl: {
                                    hd: BrowserStyle.placeholder({
                                          hd: BrowserStyle.color({
                                                TAG: /* Grey */2,
                                                _0: /* Light */3
                                              }),
                                          tl: {
                                            hd: BrowserStyle.opacity(1.0),
                                            tl: /* [] */0
                                          }
                                        }),
                                    tl: {
                                      hd: BrowserStyle.textAlign("left"),
                                      tl: {
                                        hd: BrowserStyle.width(BrowserStyle.pct(100.0)),
                                        tl: /* [] */0
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }));
}

var Styles = {
  inputContainer: inputContainer,
  icon: icon,
  input: input
};

function BrowserComponents_Input$Legacy$Address(Props) {
  var autoFocus = Props.autoFocus;
  var disabled = Props.disabled;
  var value = Props.value;
  var icon$1 = Props.icon;
  var onChange = Props.onChange;
  var placeholder = Props.placeholder;
  var className = Props.className;
  var onBlur = Props.onBlur;
  var testId = Props.testId;
  var tmp = {
    className: input(Relude_Option.isSome(icon$1)),
    disabled: disabled,
    type: "text",
    value: value,
    onChange: (function (param) {
        return Relude_Globals.$great$great(DomUtils.getValueFromEvent, onChange, param);
      })
  };
  if (autoFocus !== undefined) {
    tmp.autoFocus = Caml_option.valFromOption(autoFocus);
  }
  if (placeholder !== undefined) {
    tmp.placeholder = Caml_option.valFromOption(placeholder);
  }
  if (onBlur !== undefined) {
    tmp.onBlur = Caml_option.valFromOption(onBlur);
  }
  var tmp$1 = {
    children: React.createElement("div", {
          className: BrowserStyle.Utils.extendBaseStyle(inputContainer, className)
        }, icon$1 !== undefined ? React.createElement(BrowserComponents_Icon.make, {
                className: icon,
                icon: {
                  TAG: /* Small */1,
                  _0: icon$1
                }
              }) : null, React.createElement(ReactPlacesAutocomplete, BrowserBindings_PlacesAutoComplete.makeProps(["address"], value, undefined, onChange, undefined)(React.createElement("input", tmp), undefined, undefined)))
  };
  if (testId !== undefined) {
    tmp$1.id = Caml_option.valFromOption(testId);
  }
  return React.createElement(ReactUtils.WithTestId.make, tmp$1);
}

var Address = {
  Styles: Styles,
  make: BrowserComponents_Input$Legacy$Address
};

var convertTimeFromTwelveHour = ((time) => {
        // Date is arbitrary since we just use the time
        var date = new Date("February 04, 2011 "+time);
        var options = {
          hour: 'numeric',
          minute: 'numeric',
          hour12: true
        };
        return (date.toLocaleString('en-US', options) !== "Invalid Date") ? date.toLocaleString('en-US', options) : "6:00 PM";
      });

var convertTimeToTwelveHour = ((time12h) => {
        const [time, modifier] = time12h.split(' ');

        let [hours, minutes] = time.split(':');

        if (hours === '12') {
          hours = '00';
        }

        if (modifier && modifier.toUpperCase() === 'PM') {
          hours = parseInt(hours, 10) + 12;
        }else if ((!modifier) || (modifier && modifier.toUpperCase() !== 'AM')){
          return " ";
        }

        return `${hours}:${minutes}`;
      });

function arg(param) {
  return BrowserStyle.withFont(param, /* OpenSans */1, /* Large */4, /* Bold */2);
}

var time = Curry._1(BrowserStyle.style, Curry._1(arg(undefined), {
          hd: BrowserStyle.padding2(BrowserStyle.rem(0.75), BrowserStyle.rem(0.25)),
          tl: {
            hd: BrowserStyle.paddingRight(BrowserStyle.zero),
            tl: {
              hd: BrowserStyle.border(BrowserStyle.Input.borderWidth, BrowserStyle.solid, {
                    TAG: /* Grey */2,
                    _0: /* Light */3
                  }),
              tl: {
                hd: BrowserStyle.borderRadius(BrowserStyle.Input.borderRadius),
                tl: {
                  hd: BrowserStyle.textAlign(BrowserStyle.center),
                  tl: {
                    hd: BrowserStyle.width(BrowserStyle.pct(100.0)),
                    tl: {
                      hd: BrowserStyle.outlineStyle(BrowserStyle.none),
                      tl: {
                        hd: BrowserStyle.unsafe("-moz-appearance", "textfield"),
                        tl: /* [] */0
                      }
                    }
                  }
                }
              }
            }
          }
        }));

var Styles$1 = {
  time: time
};

function BrowserComponents_Input$Legacy$Time(Props) {
  var autoFocus = Props.autoFocus;
  var disabled = Props.disabled;
  var onBlur = Props.onBlur;
  var onChange = Props.onChange;
  var requiredOpt = Props.required;
  var testId = Props.testId;
  var value = Props.value;
  var required = requiredOpt !== undefined ? requiredOpt : false;
  var tmp;
  if (DomUtils.isSafariDesktop(undefined)) {
    var tmp$1 = {
      className: time,
      placeholder: convertTimeFromTwelveHour(value),
      required: required,
      type: "text",
      onChange: (function (param) {
          return Relude_Globals.$great$great((function (param) {
                        return Relude_Globals.$great$great(DomUtils.getValueFromEvent, convertTimeToTwelveHour, param);
                      }), onChange, param);
        })
    };
    if (autoFocus !== undefined) {
      tmp$1.autoFocus = Caml_option.valFromOption(autoFocus);
    }
    if (disabled !== undefined) {
      tmp$1.disabled = Caml_option.valFromOption(disabled);
    }
    if (onBlur !== undefined) {
      tmp$1.onBlur = Caml_option.valFromOption(onBlur);
    }
    tmp = React.createElement("input", tmp$1);
  } else {
    var tmp$2 = {
      className: time,
      required: required,
      type: "time",
      value: value,
      onChange: (function (param) {
          return Relude_Globals.$great$great(DomUtils.getValueFromEvent, onChange, param);
        })
    };
    if (autoFocus !== undefined) {
      tmp$2.autoFocus = Caml_option.valFromOption(autoFocus);
    }
    if (disabled !== undefined) {
      tmp$2.disabled = Caml_option.valFromOption(disabled);
    }
    if (onBlur !== undefined) {
      tmp$2.onBlur = Caml_option.valFromOption(onBlur);
    }
    tmp = React.createElement("input", tmp$2);
  }
  var tmp$3 = {
    children: tmp
  };
  if (testId !== undefined) {
    tmp$3.id = Caml_option.valFromOption(testId);
  }
  return React.createElement(ReactUtils.WithTestId.make, tmp$3);
}

var Time = {
  Styles: Styles$1,
  make: BrowserComponents_Input$Legacy$Time
};

var Legacy = {
  Address: Address,
  Time: Time
};

var _map = {"additionalName":"additional-name","addressLevel1":"address-level1","addressLevel2":"address-level2","addressLevel3":"address-level3","addressLevel4":"address-level4","addressLine1":"address-line1","addressLine2":"address-line2","addressLine3":"address-line3","birthday":"bday","birthdayDay":"bday-day","birthdayMonth":"bday-month","birthdayYear":"bday-year","ccAdditionalName":"cc-additional-name","ccSecurityCode":"cc-csc","ccExpirationMonth":"cc-exp-month","ccExpirationYear":"cc-exp-year","ccExpiration":"cc-exp","ccFamilyName":"cc-family-name","ccGivenName":"cc-given-name","ccName":"cc-name","ccNumber":"cc-number","ccType":"cc-type","country":"country","countryName":"country-name","currentPassword":"current-password","email":"email","familyName":"family-name","givenName":"give-name","honorificPrefix":"honorific-prefix","honorifixSuffix":"honorific-suffix","impp":"impp","language":"language","name":"name","newPassword":"new-password","nickname":"nickname","off":"off","on":"on","oneTimeCode":"one-time-code","organization":"organization","organizationTitle":"organization-title","photo":"photo","postalCode":"postal-code","sex":"sex","streetAddress":"street-address","phoneNumberAreaCode":"tel-area-code","phoneNumberCountryCode":"tel-country-code","phoneNumberExtension":"tel-extension","phoneNumberLocal":"tel-local","phoneNumberNational":"tel-national","phoneNumber":"tel","transactionAmount":"transaction-amount","transactionCurrency":"transaction-currency","url":"url","username":"username"};

var _revMap = {"additional-name":"additionalName","address-level1":"addressLevel1","address-level2":"addressLevel2","address-level3":"addressLevel3","address-level4":"addressLevel4","address-line1":"addressLine1","address-line2":"addressLine2","address-line3":"addressLine3","bday":"birthday","bday-day":"birthdayDay","bday-month":"birthdayMonth","bday-year":"birthdayYear","cc-additional-name":"ccAdditionalName","cc-csc":"ccSecurityCode","cc-exp-month":"ccExpirationMonth","cc-exp-year":"ccExpirationYear","cc-exp":"ccExpiration","cc-family-name":"ccFamilyName","cc-given-name":"ccGivenName","cc-name":"ccName","cc-number":"ccNumber","cc-type":"ccType","country":"country","country-name":"countryName","current-password":"currentPassword","email":"email","family-name":"familyName","give-name":"givenName","honorific-prefix":"honorificPrefix","honorific-suffix":"honorifixSuffix","impp":"impp","language":"language","name":"name","new-password":"newPassword","nickname":"nickname","off":"off","on":"on","one-time-code":"oneTimeCode","organization":"organization","organization-title":"organizationTitle","photo":"photo","postal-code":"postalCode","sex":"sex","street-address":"streetAddress","tel-area-code":"phoneNumberAreaCode","tel-country-code":"phoneNumberCountryCode","tel-extension":"phoneNumberExtension","tel-local":"phoneNumberLocal","tel-national":"phoneNumberNational","tel":"phoneNumber","transaction-amount":"transactionAmount","transaction-currency":"transactionCurrency","url":"url","username":"username"};

function autoCompleteToJs(param) {
  return _map[param];
}

function autoCompleteFromJs(param) {
  return _revMap[param];
}

var _map$1 = {"decimal":"decimal","email":"email","none":"none","numeric":"numeric","search":"search","tel":"tel","text":"text","url":"url"};

function inputModeToJs(param) {
  return param;
}

function inputModeFromJs(param) {
  return _map$1[param];
}

function toTypeString(param) {
  if (typeof param === "number") {
    switch (param) {
      case /* Color */0 :
          return "color";
      case /* File */1 :
          return "file";
      case /* Hidden */2 :
          return "hidden";
      case /* Image */3 :
          return "image";
      case /* Month */4 :
          return "month";
      case /* Radio */5 :
          return "radio";
      case /* Range */6 :
          return "range";
      case /* Reset */7 :
          return "reset";
      case /* Search */8 :
          return "search";
      case /* Submit */9 :
          return "submit";
      case /* Tel */10 :
          return "tel";
      case /* Time */11 :
          return "time";
      case /* Url */12 :
          return "url";
      case /* Week */13 :
          return "week";
      
    }
  } else {
    switch (param.TAG | 0) {
      case /* Checkbox */0 :
          return "checkbox";
      case /* Date */1 :
          return "date";
      case /* DatetimeLocal */2 :
          return "datetime-local";
      case /* Email */3 :
          return "email";
      case /* NumberFloat */4 :
      case /* NumberInt */5 :
          return "number";
      case /* Password */6 :
          return "password";
      case /* Text */7 :
          return "text";
      
    }
  }
}

function getCheckedValue(param) {
  if (typeof param === "number" || param.TAG !== /* Checkbox */0) {
    return ;
  } else {
    return param._0.checked;
  }
}

function getValue(param) {
  if (typeof param === "number") {
    return ;
  }
  switch (param.TAG | 0) {
    case /* NumberFloat */4 :
    case /* NumberInt */5 :
        return param._0.input.value;
    case /* Date */1 :
    case /* DatetimeLocal */2 :
    case /* Email */3 :
    case /* Password */6 :
    case /* Text */7 :
        return param._0.value;
    default:
      return ;
  }
}

function getMax(param) {
  if (typeof param === "number") {
    return ;
  }
  switch (param.TAG | 0) {
    case /* NumberFloat */4 :
        var match = param._0.clamp;
        if (match !== undefined) {
          return Relude_Option.pure(Relude_Float.toString(match.max));
        } else {
          return ;
        }
    case /* NumberInt */5 :
        var match$1 = param._0.clamp;
        if (match$1 !== undefined) {
          return Relude_Option.pure(Relude_Int.toString(match$1.max));
        } else {
          return ;
        }
    default:
      return ;
  }
}

function getMin(param) {
  if (typeof param === "number") {
    return ;
  }
  switch (param.TAG | 0) {
    case /* NumberFloat */4 :
        var match = param._0.clamp;
        if (match !== undefined) {
          return Relude_Option.pure(match.min);
        } else {
          return ;
        }
    case /* NumberInt */5 :
        var match$1 = param._0.clamp;
        if (match$1 !== undefined) {
          return Relude_Option.pure(Relude_Int.toFloat(match$1.min));
        } else {
          return ;
        }
    default:
      return ;
  }
}

function getStep(param) {
  if (typeof param === "number") {
    return ;
  }
  switch (param.TAG | 0) {
    case /* NumberFloat */4 :
        var match = param._0.clamp;
        if (match !== undefined) {
          return Relude_Option.pure(match.step);
        } else {
          return ;
        }
    case /* NumberInt */5 :
        var match$1 = param._0.clamp;
        if (match$1 !== undefined) {
          return Relude_Option.pure(Relude_Int.toFloat(match$1.step));
        } else {
          return ;
        }
    default:
      return ;
  }
}

var Value = {
  toTypeString: toTypeString,
  getCheckedValue: getCheckedValue,
  getValue: getValue,
  getMax: getMax,
  getMin: getMin,
  getStep: getStep
};

function getDisabledSafariOverride(styleType) {
  if (styleType) {
    return Curry._1(BrowserStyle.style, /* [] */0);
  } else {
    return Curry._1(BrowserStyle.style, {
                hd: Css.unsafe("-webkit-text-fill-color", Css_AtomicTypes.Color.toString(Curry._1(BrowserStyle.Color.toColor, {
                              TAG: /* Grey */2,
                              _0: /* Light */3
                            }))),
                tl: /* [] */0
              });
  }
}

function input$1(size, styleType) {
  var arg = BrowserStyle.Input.sizeToFontSize(size);
  var arg$1 = function (param) {
    return BrowserStyle.withFont(param, /* OpenSans */1, arg, /* Semibold */1);
  };
  return Curry._1(BrowserStyle.merge, {
              hd: getDisabledSafariOverride(styleType),
              tl: {
                hd: Curry._1(BrowserStyle.style, size >= 2 ? ({
                          hd: BrowserStyle.padding2(BrowserStyle.rem(0.125), BrowserStyle.zero),
                          tl: /* [] */0
                        }) : ({
                          hd: BrowserStyle.padding(BrowserStyle.zero),
                          tl: /* [] */0
                        })),
                tl: {
                  hd: Curry._1(BrowserStyle.style, Curry._1(arg$1(undefined), {
                            hd: BrowserStyle.backgroundColor(/* Transparent */2),
                            tl: {
                              hd: BrowserStyle.border(BrowserStyle.zero, BrowserStyle.solid, /* Transparent */2),
                              tl: {
                                hd: BrowserStyle.color({
                                      TAG: /* Grey */2,
                                      _0: /* Dark */1
                                    }),
                                tl: {
                                  hd: BrowserStyle.outline(BrowserStyle.zero, BrowserStyle.none, /* CurrentColor */1),
                                  tl: {
                                    hd: BrowserStyle.placeholder({
                                          hd: BrowserStyle.color({
                                                TAG: /* Grey */2,
                                                _0: /* Light */3
                                              }),
                                          tl: {
                                            hd: BrowserStyle.opacity(1.0),
                                            tl: /* [] */0
                                          }
                                        }),
                                    tl: {
                                      hd: BrowserStyle.width(BrowserStyle.pct(100.0)),
                                      tl: /* [] */0
                                    }
                                  }
                                }
                              }
                            }
                          })),
                  tl: /* [] */0
                }
              }
            });
}

var Styles$2 = {
  getDisabledSafariOverride: getDisabledSafariOverride,
  input: input$1
};

var make = React.forwardRef(function (Props, ref_) {
      var autoComplete = Props.autoComplete;
      var autoFocusOpt = Props.autoFocus;
      var className = Props.className;
      var inputMode = Props.inputMode;
      var name = Props.name;
      var onBlurOpt = Props.onBlur;
      var onFocusOpt = Props.onFocus;
      var onKeyDownOpt = Props.onKeyDown;
      var placeholder = Props.placeholder;
      var requiredOpt = Props.required;
      var testId = Props.testId;
      var sizeOpt = Props.size;
      var styleType = Props.styleType;
      var value = Props.value;
      var autoFocus = autoFocusOpt !== undefined ? autoFocusOpt : false;
      var onBlur = onBlurOpt !== undefined ? onBlurOpt : Relude_IO.pure(undefined);
      var onFocus = onFocusOpt !== undefined ? onFocusOpt : (function (param) {
            return Relude_Globals.$great$great((function (prim) {
                          
                        }), Relude_IO.pure, param);
          });
      var onKeyDown = onKeyDownOpt !== undefined ? onKeyDownOpt : (function (param) {
            return Relude_Globals.$great$great((function (prim) {
                          
                        }), Relude_IO.pure, param);
          });
      var required = requiredOpt !== undefined ? requiredOpt : false;
      var size = sizeOpt !== undefined ? sizeOpt : /* Medium */2;
      var tmp = {
        className: BrowserStyle.Utils.extendBaseStyle(input$1(size, styleType), className),
        autoFocus: autoFocus,
        disabled: BrowserStyle.Input.isDisabled(styleType),
        required: required,
        type: toTypeString(value),
        onKeyDown: (function (param) {
            return Relude_Globals.$great$great((function (param) {
                          return Relude_Globals.$great$great(DomUtils.KeyMappings.getKeyFromEvent, onKeyDown, param);
                        }), IOUtils.unsafeRunHandledAsync, param);
          }),
        onFocus: (function (param) {
            return Relude_Globals.$great$great((function (param) {
                          return Relude_Globals.$great$great(Relude_IO.pure, (function (param) {
                                        return Relude_IO.flatMap(onFocus, param);
                                      }), param);
                        }), IOUtils.unsafeRunHandledAsync, param);
          }),
        onBlur: (function (param) {
            return Relude_Globals.$great$great((function (param) {
                          return Relude_Globals.$$const(onBlur, param);
                        }), IOUtils.unsafeRunHandledAsync, param);
          }),
        onChange: (function (param) {
            return Relude_Globals.$great$great((function (param) {
                          return Relude_Globals.$great$great((function (param) {
                                        return Relude_Tuple2.make(value, param);
                                      }), (function (param) {
                                        var match = param[0];
                                        var exit = 0;
                                        if (typeof match === "number") {
                                          return Relude_IO.pure(undefined);
                                        }
                                        switch (match.TAG | 0) {
                                          case /* Checkbox */0 :
                                              return Curry._1(match._0.onChange, DomUtils.getCheckedFromEvent(param[1]));
                                          case /* NumberFloat */4 :
                                          case /* NumberInt */5 :
                                              exit = 2;
                                              break;
                                          case /* Date */1 :
                                          case /* DatetimeLocal */2 :
                                          case /* Email */3 :
                                          case /* Password */6 :
                                          case /* Text */7 :
                                              exit = 1;
                                              break;
                                          
                                        }
                                        switch (exit) {
                                          case 1 :
                                              var onChange = match._0.onChange;
                                              return Curry._1(onChange, DomUtils.getValueFromEvent(param[1]));
                                          case 2 :
                                              var onChange$1 = match._0.input.onChange;
                                              return Curry._1(onChange$1, DomUtils.getValueFromEvent(param[1]));
                                          
                                        }
                                      }), param);
                        }), IOUtils.unsafeRunHandledAsync, param);
          })
      };
      var tmp$1 = Relude_Option.map((function (prim) {
              return prim;
            }), (ref_ == null) ? undefined : Caml_option.some(ref_));
      if (tmp$1 !== undefined) {
        tmp.ref = Caml_option.valFromOption(tmp$1);
      }
      if (autoComplete !== undefined) {
        tmp.autoComplete = Caml_option.valFromOption(autoComplete);
      }
      var tmp$2 = getCheckedValue(value);
      if (tmp$2 !== undefined) {
        tmp.checked = Caml_option.valFromOption(tmp$2);
      }
      if (inputMode !== undefined) {
        tmp.inputMode = Caml_option.valFromOption(inputMode);
      }
      var tmp$3 = getMax(value);
      if (tmp$3 !== undefined) {
        tmp.max = Caml_option.valFromOption(tmp$3);
      }
      var tmp$4 = getMin(value);
      if (tmp$4 !== undefined) {
        tmp.min = Caml_option.valFromOption(tmp$4);
      }
      if (name !== undefined) {
        tmp.name = Caml_option.valFromOption(name);
      }
      if (placeholder !== undefined) {
        tmp.placeholder = Caml_option.valFromOption(placeholder);
      }
      var tmp$5 = getStep(value);
      if (tmp$5 !== undefined) {
        tmp.step = Caml_option.valFromOption(tmp$5);
      }
      var tmp$6 = getValue(value);
      if (tmp$6 !== undefined) {
        tmp.value = Caml_option.valFromOption(tmp$6);
      }
      var tmp$7 = {
        children: React.createElement("input", tmp)
      };
      if (testId !== undefined) {
        tmp$7.id = Caml_option.valFromOption(testId);
      }
      return React.createElement(ReactUtils.WithTestId.make, tmp$7);
    });

var Base = {
  Value: Value,
  Styles: Styles$2,
  make: make
};

function BrowserComponents_Input$BaseStatefulStyleType(Props) {
  var autoFocus = Props.autoFocus;
  var className = Props.className;
  var disabledOpt = Props.disabled;
  var onBlur = Props.onBlur;
  var onFocus = Props.onFocus;
  var onKeyDown = Props.onKeyDown;
  var placeholder = Props.placeholder;
  var requiredOpt = Props.required;
  var size = Props.size;
  var testId = Props.testId;
  var validationStatus = Props.validationStatus;
  var value = Props.value;
  var disabled = disabledOpt !== undefined ? disabledOpt : false;
  var required = requiredOpt !== undefined ? requiredOpt : false;
  var match = Curry._2(BrowserStyle.Input.useInput(onFocus)(disabled), onBlur, validationStatus);
  var tmp = {
    onBlur: match.onBlur,
    onFocus: match.onFocus,
    required: required,
    styleType: match.styleType,
    value: value
  };
  if (autoFocus !== undefined) {
    tmp.autoFocus = Caml_option.valFromOption(autoFocus);
  }
  if (className !== undefined) {
    tmp.className = Caml_option.valFromOption(className);
  }
  if (onKeyDown !== undefined) {
    tmp.onKeyDown = Caml_option.valFromOption(onKeyDown);
  }
  if (placeholder !== undefined) {
    tmp.placeholder = Caml_option.valFromOption(placeholder);
  }
  if (testId !== undefined) {
    tmp.testId = Caml_option.valFromOption(testId);
  }
  if (size !== undefined) {
    tmp.size = Caml_option.valFromOption(size);
  }
  return React.createElement(make, tmp);
}

var BaseStatefulStyleType = {
  make: BrowserComponents_Input$BaseStatefulStyleType
};

var container = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignItems(BrowserStyle.center),
      tl: /* [] */0
    });

var input$2 = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.flex({
            NAME: "num",
            VAL: 0.0
          }),
      tl: {
        hd: BrowserStyle.textAlign("right"),
        tl: {
          hd: BrowserStyle.width(BrowserStyle.rem(4.5)),
          tl: /* [] */0
        }
      }
    });

var Styles$3 = {
  container: container,
  input: input$2
};

function BrowserComponents_Input$AmountCents(Props) {
  var className = Props.className;
  var disabledOpt = Props.disabled;
  var onBlur = Props.onBlur;
  var onChange = Props.onChange;
  var onFocus = Props.onFocus;
  var size = Props.size;
  var testId = Props.testId;
  var theme = Props.theme;
  var validationStatus = Props.validationStatus;
  var value = Props.value;
  var disabled = disabledOpt !== undefined ? disabledOpt : false;
  var partial_arg = {
    TAG: /* Red */5,
    _0: /* Medium */2
  };
  var tmp = {
    children: {
      TAG: /* Input */1,
      _0: (function (param) {
          var tmp = {
            className: input$2,
            inputMode: "numeric",
            onBlur: param.onBlur,
            onFocus: param.onFocus,
            placeholder: "0.00",
            styleType: param.styleType,
            value: {
              TAG: /* Text */7,
              _0: {
                onChange: (function (param) {
                    return Relude_Globals.$great$great((function (param) {
                                  return Relude_Globals.$great$great(StringUtils.getNumbersOnly, Relude_String.toInt, param);
                                }), onChange, param);
                  }),
                value: Relude_Option.fold("", MathUtils.centsToString, value)
              }
            }
          };
          if (testId !== undefined) {
            tmp.testId = Caml_option.valFromOption(testId);
          }
          if (size !== undefined) {
            tmp.size = Caml_option.valFromOption(size);
          }
          return React.createElement(make, tmp);
        })
    },
    disabled: disabled
  };
  if (onBlur !== undefined) {
    tmp.onBlur = Caml_option.valFromOption(onBlur);
  }
  if (onFocus !== undefined) {
    tmp.onFocus = Caml_option.valFromOption(onFocus);
  }
  if (size !== undefined) {
    tmp.size = Caml_option.valFromOption(size);
  }
  if (theme !== undefined) {
    tmp.theme = Caml_option.valFromOption(theme);
  }
  var tmp$1 = Relude_Option.map((function (param) {
          return Relude_Result.bimap((function (prim) {
                        
                      }), (function (param) {
                        return Relude_Globals.$$const("", param);
                      }), param);
        }), validationStatus);
  if (tmp$1 !== undefined) {
    tmp.validationStatus = Caml_option.valFromOption(tmp$1);
  }
  return React.createElement(BrowserComponents_FlexRow.make, {
              className: BrowserStyle.Utils.extendBaseStyle(container, className),
              children: null
            }, React.createElement(BrowserComponents_Icon.make, {
                  color: Relude_Option.fold({
                        TAG: /* Grey */2,
                        _0: /* Dark */1
                      }, (function (param) {
                          return Relude_Globals.$$const(partial_arg, param);
                        }), Curry._2(Relude_Option.flatMap, Relude_Result.getError, validationStatus)),
                  icon: {
                    TAG: /* Small */1,
                    _0: {
                      TAG: /* InputField */2,
                      _0: /* Dollar */1
                    }
                  },
                  size: /* Small */1
                }), React.createElement(BrowserComponents_Spacer.make, {
                  size: /* XSmall */2
                }), React.createElement(BrowserComponents_Field.make, tmp));
}

var AmountCents = {
  Styles: Styles$3,
  make: BrowserComponents_Input$AmountCents
};

var make$1 = React.forwardRef(function (Props, ref_) {
      var autoComplete = Props.autoComplete;
      var autoFocus = Props.autoFocus;
      var className = Props.className;
      var containerClassName = Props.containerClassName;
      var disabledOpt = Props.disabled;
      var hint = Props.hint;
      var iconLeft = Props.iconLeft;
      var iconRight = Props.iconRight;
      var inputClassName = Props.inputClassName;
      var inputMode = Props.inputMode;
      var name = Props.name;
      var onBlur = Props.onBlur;
      var onFocus = Props.onFocus;
      var onKeyDown = Props.onKeyDown;
      var placeholder = Props.placeholder;
      var requiredOpt = Props.required;
      var size = Props.size;
      var testId = Props.testId;
      var theme = Props.theme;
      var title = Props.title;
      var titleAndFieldContainerClassName = Props.titleAndFieldContainerClassName;
      var titleColor = Props.titleColor;
      var titleIcon = Props.titleIcon;
      var titleSize = Props.titleSize;
      var validationStatus = Props.validationStatus;
      var value = Props.value;
      var disabled = disabledOpt !== undefined ? disabledOpt : false;
      var required = requiredOpt !== undefined ? requiredOpt : false;
      var tmp = {
        children: {
          TAG: /* Input */1,
          _0: (function (param) {
              var tmp = {
                onBlur: param.onBlur,
                onFocus: param.onFocus,
                required: required,
                styleType: param.styleType,
                value: value
              };
              var tmp$1 = Relude_Option.map(autoCompleteToJs, autoComplete);
              if (tmp$1 !== undefined) {
                tmp.autoComplete = Caml_option.valFromOption(tmp$1);
              }
              if (autoFocus !== undefined) {
                tmp.autoFocus = Caml_option.valFromOption(autoFocus);
              }
              if (inputClassName !== undefined) {
                tmp.className = Caml_option.valFromOption(inputClassName);
              }
              var tmp$2 = Relude_Option.map(inputModeToJs, inputMode);
              if (tmp$2 !== undefined) {
                tmp.inputMode = Caml_option.valFromOption(tmp$2);
              }
              if (name !== undefined) {
                tmp.name = Caml_option.valFromOption(name);
              }
              if (onKeyDown !== undefined) {
                tmp.onKeyDown = Caml_option.valFromOption(onKeyDown);
              }
              if (placeholder !== undefined) {
                tmp.placeholder = Caml_option.valFromOption(placeholder);
              }
              if (testId !== undefined) {
                tmp.testId = Caml_option.valFromOption(testId);
              }
              if (size !== undefined) {
                tmp.size = Caml_option.valFromOption(size);
              }
              var tmp$3 = Relude_Option.map((function (prim) {
                      return prim;
                    }), (ref_ == null) ? undefined : Caml_option.some(ref_));
              if (tmp$3 !== undefined) {
                tmp.ref = Caml_option.valFromOption(tmp$3);
              }
              return React.createElement(make, tmp);
            })
        },
        disabled: disabled
      };
      if (className !== undefined) {
        tmp.className = Caml_option.valFromOption(className);
      }
      if (containerClassName !== undefined) {
        tmp.containerClassName = Caml_option.valFromOption(containerClassName);
      }
      if (hint !== undefined) {
        tmp.hint = Caml_option.valFromOption(hint);
      }
      if (iconLeft !== undefined) {
        tmp.iconLeft = Caml_option.valFromOption(iconLeft);
      }
      if (iconRight !== undefined) {
        tmp.iconRight = Caml_option.valFromOption(iconRight);
      }
      if (onBlur !== undefined) {
        tmp.onBlur = Caml_option.valFromOption(onBlur);
      }
      if (onFocus !== undefined) {
        tmp.onFocus = Caml_option.valFromOption(onFocus);
      }
      if (size !== undefined) {
        tmp.size = Caml_option.valFromOption(size);
      }
      if (theme !== undefined) {
        tmp.theme = Caml_option.valFromOption(theme);
      }
      if (title !== undefined) {
        tmp.title = Caml_option.valFromOption(title);
      }
      if (titleAndFieldContainerClassName !== undefined) {
        tmp.titleAndFieldContainerClassName = Caml_option.valFromOption(titleAndFieldContainerClassName);
      }
      if (titleColor !== undefined) {
        tmp.titleColor = Caml_option.valFromOption(titleColor);
      }
      if (titleIcon !== undefined) {
        tmp.titleIcon = Caml_option.valFromOption(titleIcon);
      }
      if (titleSize !== undefined) {
        tmp.titleSize = Caml_option.valFromOption(titleSize);
      }
      var tmp$1 = Relude_Option.map((function (param) {
              return Relude_Result.map((function (prim) {
                            
                          }), param);
            }), validationStatus);
      if (tmp$1 !== undefined) {
        tmp.validationStatus = Caml_option.valFromOption(tmp$1);
      }
      return React.createElement(BrowserComponents_Field.make, tmp);
    });

function makeProps(validationStatus) {
  var arg = Relude_Option.map((function (param) {
          return Relude_Result.map((function (prim) {
                        
                      }), param);
        }), validationStatus);
  return function (param, param$1, param$2, param$3, param$4, param$5, param$6, param$7, param$8, param$9, param$10, param$11, param$12, param$13, param$14, param$15, param$16, param$17, param$18, param$19, param$20, param$21, param$22, param$23) {
    return function (param$24, param$25, param$26, param$27) {
      var tmp = {
        value: param$24
      };
      if (param !== undefined) {
        tmp.autoComplete = Caml_option.valFromOption(param);
      }
      if (param$1 !== undefined) {
        tmp.autoFocus = Caml_option.valFromOption(param$1);
      }
      if (param$2 !== undefined) {
        tmp.className = Caml_option.valFromOption(param$2);
      }
      if (param$3 !== undefined) {
        tmp.containerClassName = Caml_option.valFromOption(param$3);
      }
      if (param$4 !== undefined) {
        tmp.disabled = Caml_option.valFromOption(param$4);
      }
      if (param$5 !== undefined) {
        tmp.hint = Caml_option.valFromOption(param$5);
      }
      if (param$6 !== undefined) {
        tmp.iconLeft = Caml_option.valFromOption(param$6);
      }
      if (param$7 !== undefined) {
        tmp.iconRight = Caml_option.valFromOption(param$7);
      }
      if (param$8 !== undefined) {
        tmp.inputClassName = Caml_option.valFromOption(param$8);
      }
      if (param$9 !== undefined) {
        tmp.inputMode = Caml_option.valFromOption(param$9);
      }
      if (param$10 !== undefined) {
        tmp.name = Caml_option.valFromOption(param$10);
      }
      if (param$11 !== undefined) {
        tmp.onBlur = Caml_option.valFromOption(param$11);
      }
      if (param$12 !== undefined) {
        tmp.onFocus = Caml_option.valFromOption(param$12);
      }
      if (param$13 !== undefined) {
        tmp.onKeyDown = Caml_option.valFromOption(param$13);
      }
      if (param$14 !== undefined) {
        tmp.placeholder = Caml_option.valFromOption(param$14);
      }
      if (param$15 !== undefined) {
        tmp.required = Caml_option.valFromOption(param$15);
      }
      if (param$16 !== undefined) {
        tmp.size = Caml_option.valFromOption(param$16);
      }
      if (param$17 !== undefined) {
        tmp.testId = Caml_option.valFromOption(param$17);
      }
      if (param$18 !== undefined) {
        tmp.theme = Caml_option.valFromOption(param$18);
      }
      if (param$19 !== undefined) {
        tmp.title = Caml_option.valFromOption(param$19);
      }
      if (param$20 !== undefined) {
        tmp.titleAndFieldContainerClassName = Caml_option.valFromOption(param$20);
      }
      if (param$21 !== undefined) {
        tmp.titleColor = Caml_option.valFromOption(param$21);
      }
      if (param$22 !== undefined) {
        tmp.titleIcon = Caml_option.valFromOption(param$22);
      }
      if (param$23 !== undefined) {
        tmp.titleSize = Caml_option.valFromOption(param$23);
      }
      if (arg !== undefined) {
        tmp.validationStatus = Caml_option.valFromOption(arg);
      }
      if (param$25 !== undefined) {
        tmp.key = Caml_option.valFromOption(param$25);
      }
      if (param$26 !== undefined) {
        tmp.ref = Caml_option.valFromOption(param$26);
      }
      return tmp;
    };
  };
}

exports.Legacy = Legacy;
exports.autoCompleteToJs = autoCompleteToJs;
exports.autoCompleteFromJs = autoCompleteFromJs;
exports.inputModeToJs = inputModeToJs;
exports.inputModeFromJs = inputModeFromJs;
exports.Base = Base;
exports.BaseStatefulStyleType = BaseStatefulStyleType;
exports.AmountCents = AmountCents;
exports.make = make$1;
exports.makeProps = makeProps;
/* inputContainer Not a pure module */
